import { create } from "zustand";

export type QuestionTipsTrigger = "auto" | "manual";

type State = {
	openedVia?: QuestionTipsTrigger;
	openQuestionTips: (trigger: QuestionTipsTrigger) => void;
	closeQuestionTips: () => void;
};

export const useQuestionTipsStore = create<State>()((set) => ({
	openQuestionTips: (trigger) => set({ openedVia: trigger }),
	closeQuestionTips: () => set({ openedVia: undefined }),
}));
